import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { testimonials } from "@/data/landing";
import { fadeUp } from "@/lib/motion";

const TestimonialCard = ({ t, idx }) => (
    <div
        data-testid={`testimonial-${idx}`}
        className="w-[340px] md:w-[420px] shrink-0 glass rounded-2xl p-7 mr-5"
    >
        <Quote className="h-7 w-7 text-cyan-300/60" strokeWidth={1.5} />
        <p className="mt-4 text-zinc-200 text-[15px] leading-relaxed min-h-[160px]">
            &ldquo;{t.quote}&rdquo;
        </p>
        <div className="mt-5 flex items-center gap-1">
            {Array.from({ length: t.rating }).map((_, i) => (
                <Star key={i} className="h-4 w-4 text-cyan-300 fill-cyan-300" />
            ))}
        </div>
        <div className="mt-5 flex items-center gap-3 pt-5 border-t border-white/5">
            <img
                src={t.avatar}
                alt={t.name}
                loading="lazy"
                className="h-11 w-11 rounded-full object-cover border border-white/15"
            />
            <div>
                <div className="text-white font-semibold text-sm">{t.name}</div>
                <div className="text-zinc-500 text-xs">
                    {t.role} <span className="text-zinc-700">·</span> {t.city}
                </div>
            </div>
        </div>
    </div>
);

const Testimonials = () => {
    const row = [...testimonials, ...testimonials];
    return (
        <section
            id="testimonials"
            data-testid="testimonials-section"
            className="section py-24 md:py-32 bg-[#070708]/70"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-12">
                <motion.div {...fadeUp} className="max-w-3xl">
                    <span className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-300">
                        05 / Testimonials
                    </span>
                    <h2
                        data-testid="testimonials-heading"
                        className="mt-4 font-display font-semibold text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
                    >
                        Loved across
                        <br />
                        <span className="text-grad-cyan">23+ Indian states.</span>
                    </h2>
                </motion.div>
            </div>

            <div className="relative">
                <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#050505] to-transparent z-10" />
                <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#050505] to-transparent z-10" />
                <div className="overflow-hidden">
                    <div className="flex marquee" style={{ width: "max-content" }}>
                        {row.map((t, i) => (
                            <TestimonialCard key={i} t={t} idx={i} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
